import { Controller, useFieldArray, useForm, useFormContext } from "react-hook-form";
import { FiInfo } from "react-icons/fi";
import { TextInput } from "../inputs"
import Langs from '../../utils/data/langs.json'

const PRICE_TIERS = [
    { label: "Single course", range: "1–4 per order" },
    { label: "5+ courses", range: "5–9 per order" },
    { label: "10+ courses", range: "10+ per order" },
];
const Tarif = () => {

    const {
        register,
        formState: { errors },
        watch,
        control,
    } = useFormContext();

    const {
        fields: langList,
    } = useFieldArray({
        control,
        name: "prices",
    });
    
    return (
        <div className=" mx-auto">
            <h2 className="mb-1 text-nt-blue">Tarif</h2>
            <p className="text-nt-blue font-medium text-sm mb-4">Please enter the price for each language you teach.</p>
            <div className="mb-5 flex gap-3 rounded-xl border border-nt-grey-light/80 bg-nt-grey-light/50 px-4 py-3">
                <FiInfo className="mt-0.5 shrink-0 text-nt-grey" size={16} aria-hidden />
                <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium text-nt-blue">Price per course by order size</p>
                    <ul className="mt-2 grid gap-2 sm:grid-cols-3 sm:gap-4">
                        {PRICE_TIERS.map(({ label, range }) => (
                            <li key={label} className="text-xs leading-snug text-nt-grey">
                                <span className="font-medium text-nt-blue/80">{label}</span>
                                <span className="mx-1 text-nt-grey/60">·</span>
                                {range}
                            </li>
                        ))}
                    </ul>
                    <div className="mt-3 border-t border-nt-grey-light/60 pt-2">
                        <p className="text-xs font-medium text-nt-blue/70">Example</p>
                        <ul className="mt-1.5 grid gap-1 text-xs text-nt-grey sm:mt-2 sm:grid-cols-3 sm:gap-4">
                            <li>Single course · <span className="font-medium text-nt-blue/80">13€</span></li>
                            <li>5+ courses · <span className="font-medium text-nt-blue/80">12€</span>/course</li>
                            <li>10+ courses · <span className="font-medium text-nt-blue/80">10€</span>/course</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="xl:grid gap-10 xl:grid-cols-1">
                <Controller
                    control={control}
                    name="prices"
                    render={({ field }) => {
                        {
                            return langList.map((lang, index) => {
                                const five = watch(`prices[${index}].priceFive`);
                                const price = watch(`prices[${index}].price`);

                                return (<div key={lang.id} className="mb-4">
                                    <h4 className="text-nt-blue mb-2 text-sm font-medium">{Langs.find((v) => v.value == lang.abbr)?.name ?? lang.abbr}</h4>
                                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                                        <TextInput
                                            name={`prices[${index}].price`}
                                            label={"Single Course"}
                                            errors={errors}
                                            type="number"
                                            register={register}
                                            control={control}
                                            marginBottom="0"
                                            inputStyle={{ width: "100%" }}
                                            validationSchema={{
                                                required: "This field is required",
                                                validate: (value) => {
                                                    return value < 10 ? "Minimum value is 10" : true;
                                                }
                                            }}
                                        />
                                        <TextInput
                                            name={`prices[${index}].priceFive`}
                                            label={"5+ Courses"}
                                            errors={errors}
                                            type="number"
                                            register={register}
                                            control={control}
                                            marginBottom="0"
                                            inputStyle={{ width: "100%" }}
                                            validationSchema={{
                                                required: "This field is required",
                                                validate: (value) => {
                                                    return value < 10 ?
                                                        "Minimum value is 10" :
                                                        value > price ?
                                                            "Maximum value is " + price :
                                                            true;
                                                }
                                            }}
                                        />
                                        <TextInput
                                            name={`prices[${index}].priceTen`}
                                            label={"10+ Courses"}
                                            errors={errors}
                                            type="number"
                                            register={register}
                                            control={control}
                                            marginBottom="0"
                                            inputStyle={{ width: "100%" }}
                                            validationSchema={{
                                                required: "This field is required",
                                                validate: (value) => {
                                                    return value < 10 ?
                                                        "Minimum value is 10" :
                                                        value > five ?
                                                            "Maximum value is " + five :
                                                            true;
                                                }
                                            }}
                                        />
                                    </div>
                                </div>)
                            })
                        }
                    }}

                />
            </div>
            <div className="bg-nt-grey-light p-5 rounded-xl w-full">
                <table className="w-full">
                    <thead>
                        <tr>
                            <th className="text-nt-blue text-left align-top">Total number of completed hours</th>
                            <th className="text-nt-blue text-left align-top">Commission rate</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>0-20 hours</td>
                            <td><span className="line-through decoration-2 decoration-nt-red mr-4">30%</span>15%</td>
                        </tr>
                        <tr>
                            <td>21 - 50 hours</td>
                            <td><span className="line-through decoration-2 decoration-nt-red mr-4">28%</span>14%</td>
                        </tr>
                        <tr>
                            <td>51 - 200 hours</td>
                            <td><span className="line-through decoration-2 decoration-nt-red mr-4">25%</span>12.5%</td>
                        </tr>
                        <tr>
                            <td>201 - 400 hours</td>
                            <td><span className="line-through decoration-2 decoration-nt-red mr-4">22%</span>11%</td>
                        </tr>
                        <tr>
                            <td>400+ hours</td>
                            <td><span className="line-through decoration-2 decoration-nt-red mr-4">18%</span>9%</td>
                        </tr>
                    </tbody>
                </table>
                <div className="flex flex-col sm:flex-row mt-5 justify-between border-t-2 border-nt-blue">
                <p className="text-nt-red">* Each first lesson is <b>Free</b></p>
                </div>
            </div>
        </div>
    )
}

export { Tarif }